import React from 'react';
import DatePicker from 'react-datepicker';
import {getFormattedDate} from '../../Utils';
import 'react-datepicker/dist/react-datepicker.css';

export default function CustomDatePicker({handleChange, data, valueField}) {
  const value = valueField[data.id] ? new Date(valueField[data.id]) : null;

  const handleChangeDate = async newValue => {
    let formatted = await getFormattedDate(newValue);
    console.log(formatted, 'formattedformattedformatted');
    handleChange(formatted, data.id);
  };

  return (
    <div style={{zIndex: 1000000}} className="styleDatePicket">
      <label style={{display: 'block', marginBottom: 4}}>{data?.item}</label>

      <DatePicker
        width={'100%'}
        selected={value}
        onChange={handleChangeDate}
        dateFormat="dd/MM/yyyy"
        className="form-control"
        placeholderText="Selecciona una fecha"
      />
    </div>
  );
}
